export const environment = {
  baseUrl: '/api',
  production: true,
};
